import { HTMLAttributes } from 'react';

import { DropdownMenuLabel } from '../../primitives/dropdown-menu';
import { cn } from '../../utils/cn';

interface DropdownMenuLabelClampProp extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  clamp?: number;
  text: string;
}

/**
 * Set `className="w-full"` If the wrapper `DropdownMenuContent` has an static width
 * to fit the parent container.
 */
export function DropdownMenuLabelClamp({ clamp = 3, className, text }: DropdownMenuLabelClampProp) {
  const lineClamp = `line-clamp-${clamp.toString()}`;

  return (
    <DropdownMenuLabel>
      <div className={cn('w-[7.5rem] p-0 break-words text-muted-foreground', lineClamp, className)}>
        {text}
      </div>
    </DropdownMenuLabel>
  );
}
